import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactLoading from "react-loading";
import mainHelper, { apiCall } from "../../helpers/MainHelper";

export class QuickStockModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            currentStock: null,
            stockLoading: false,
            stockError: null,
            formData: {
                warehouse_id: '',
                quantity: '',
                notes: ''
            }
        };
    }

    componentDidUpdate(prevProps) {
        // Modal açıldığında formu sıfırla
        if (this.props.isOpen && (!prevProps.isOpen || this.props.stockItem?.id !== prevProps.stockItem?.id)) {
            this.stockRequest = (this.stockRequest || 0) + 1;
            this.setState({
                formData: {
                    warehouse_id: '',
                    quantity: '',
                    notes: ''
                },
                currentStock: null, stockLoading: false, stockError: null
            });
        }
        if (!this.props.isOpen && prevProps.isOpen) this.stockRequest = (this.stockRequest || 0) + 1;
    }

    componentWillUnmount() { this.stockRequest = (this.stockRequest || 0) + 1; }

    handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'warehouse_id') {
            this.stockRequest = (this.stockRequest || 0) + 1;
            this.setState({ currentStock: null, stockError: null, stockLoading: Boolean(value) });
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }), () => {
            // Depo seçildiğinde mevcut stoğu çek
            if (name === 'warehouse_id' && value && this.props.stockItem) {
                this.fetchCurrentStock(value);
            }
        });
    };

    fetchCurrentStock = async (warehouseId) => {
        const { stockItem } = this.props;
        if (!stockItem || !warehouseId) return;
        const request = this.stockRequest = (this.stockRequest || 0) + 1;
        this.setState({ stockLoading: true, currentStock: null, stockError: null });

        try {
            const response = await apiCall(`business/stock/item/warehouse-stock/${stockItem.id}`, 'get');
            if (request !== this.stockRequest) return;
            if (response.status === 'success' && Array.isArray(response.data)) {
                const warehouseStock = response.data.find(ws => ws.warehouse_id == warehouseId);
                this.setState({
                    currentStock: warehouseStock ? Number(this.props.movementType === 'sale'
                        ? (warehouseStock.available_quantity ?? warehouseStock.quantity ?? 0)
                        : (warehouseStock.quantity ?? 0)) : 0,
                    stockLoading: false
                });
            } else throw new Error('Stok bilgisi alınamadı');
        } catch (e) {
            if (request !== this.stockRequest) return;
            console.error('Stok bilgisi alınamadı:', e);
            this.setState({ currentStock: null, stockLoading: false, stockError: 'Stok bilgisi alınamadı. Depoyu yeniden seçerek tekrar deneyin.' });
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        const { stockItem, movementType, onSuccess, toggle } = this.props;
        const { formData, currentStock } = this.state;
        if (this.state.stockLoading || this.state.stockError || currentStock === null) {
            mainHelper.toastMessage('error', 'Önce depo stok bilgisinin yüklenmesi gerekiyor.');
            return;
        }

        if (!formData.warehouse_id || !formData.quantity) {
            mainHelper.toastMessage('error', 'Lütfen tüm zorunlu alanları doldurun!');
            return;
        }

        const quantity = parseFloat(formData.quantity);

        // Validasyon kontrolleri
        if (!Number.isFinite(quantity) || quantity <= 0) {
            mainHelper.toastMessage('error', 'Miktar 0\'dan büyük olmalıdır!');
            return;
        }

        // Stok çıkarma kontrolü
        if (movementType === 'sale' && currentStock !== null) {
            if (quantity > currentStock) {
                mainHelper.toastMessage('error', `Yetersiz stok! Mevcut stok: ${currentStock} adet. ${quantity} adet çıkış yapamazsınız.`);
                return;
            }
        }

        // Max stok kontrolü
        if (movementType === 'purchase' && stockItem.max_stock_level > 0 && currentStock !== null) {
            const newQuantity = currentStock + quantity;
            if (newQuantity > stockItem.max_stock_level) {
                mainHelper.toastMessage('error', `Maksimum stok seviyesi aşılacak! Mevcut: ${currentStock}, Eklenecek: ${quantity}, Maksimum: ${stockItem.max_stock_level}`);
                return;
            }
        }

        this.setState({ loading: true });

        const movementData = {
            stock_item_id: stockItem.id,
            warehouse_id: formData.warehouse_id,
            movement_type: movementType, // 'purchase' veya 'sale'
            quantity: parseFloat(formData.quantity),
            notes: formData.notes || `Hızlı ${movementType === 'purchase' ? 'Giriş' : 'Çıkış'}`,
            movement_date: new Date().toISOString().split('T')[0]
        };

        try {
            const response = await apiCall('business/stock/movement/add', 'post', JSON.stringify(movementData), {
                'Content-Type': 'application/json'
            });
            
            mainHelper.toastMessage(response.status, response.message);
            
            if (response.status === 'success') {
                this.setState({
                    formData: {
                        warehouse_id: '',
                        quantity: '',
                        notes: ''
                    }
                });
                toggle();
                if (onSuccess) {
                    onSuccess();
                }
            }
        } catch (e) {
            console.error(e);
            mainHelper.toastMessage('error', 'İşlem sırasında bir hata oluştu');
        }
        
        this.setState({ loading: false });
    };

    render() {
        const { isOpen, toggle, stockItem, movementType, warehouses } = this.props;
        const { loading, formData, currentStock, stockLoading, stockError } = this.state;

        const isAddStock = movementType === 'purchase';
        const modalTitle = isAddStock ? 'Hızlı Stok Girişi' : 'Hızlı Stok Çıkışı';
        const modalColor = isAddStock ? 'success' : 'danger';
        const buttonLabel = isAddStock ? 'Stok Ekle' : 'Stok Çıkar';
        const iconClass = isAddStock ? 'icon-plus' : 'icon-minus';

        // Validasyon kontrolleri
        const quantity = parseFloat(formData.quantity || 0);
        const hasInsufficientStock = !isAddStock && currentStock !== null && quantity > currentStock;
        const maxStockLevel = stockItem?.max_stock_level || 0;
        const newQuantity = isAddStock && currentStock !== null ? currentStock + quantity : 0;
        const exceedsMaxStock = isAddStock && maxStockLevel > 0 && newQuantity > maxStockLevel;
        const hasValidationError = hasInsufficientStock || exceedsMaxStock;

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} className={`bg-${modalColor} text-white`}>
                    <i className={iconClass}></i> {modalTitle}
                </ModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="alert alert-info">
                                    <strong>Ürün:</strong> {stockItem?.name || '-'} 
                                    {stockItem?.sku && <span className="ml-2">({stockItem.sku})</span>}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Depo <span className="text-danger">*</span></label>
                                    <select
                                        name="warehouse_id"
                                        className="form-control"
                                        value={formData.warehouse_id}
                                        onChange={this.handleChange}
                                        required
                                    >
                                        <option value="">Depo Seçiniz</option>
                                        {warehouses && warehouses.map(warehouse => (
                                            <option key={warehouse.id} value={warehouse.id}>
                                                {warehouse.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Miktar <span className="text-danger">*</span></label>
                                    <input
                                        type="number"
                                        name="quantity"
                                        className={`form-control ${hasValidationError ? 'is-invalid' : ''}`}
                                        placeholder="Miktar giriniz"
                                        value={formData.quantity}
                                        onChange={this.handleChange}
                                        min="0.01"
                                        step="0.01"
                                        style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
                                        required
                                    />
                                    
                                    {/* Mevcut Stok Bilgisi */}
                                    {stockLoading && <small role="status">Stok bilgisi yükleniyor...</small>}
                                    {stockError && <small role="alert" className="text-danger">{stockError}</small>}
                                    {currentStock !== null && formData.warehouse_id && (
                                        <div className={`mt-2 p-2 rounded ${hasValidationError ? 'bg-danger' : 'bg-light'}`}>
                                            <small className={hasValidationError ? 'text-white font-weight-bold' : 'text-dark'}>
                                                <strong>Mevcut Stok:</strong> {Math.round(currentStock)} {stockItem?.unit || 'adet'}
                                            </small>
                                            
                                            {/* Max Stok Bilgisi */}
                                            {isAddStock && maxStockLevel > 0 && (
                                                <small className={`d-block ${exceedsMaxStock ? 'text-white font-weight-bold' : 'text-muted'}`}>
                                                    <strong>Maksimum:</strong> {Math.round(maxStockLevel)} {stockItem?.unit || 'adet'}
                                                </small>
                                            )}

                                            {/* Giriş Sonrası Bilgisi */}
                                            {isAddStock && quantity > 0 && (
                                                <small className={`d-block ${exceedsMaxStock ? 'text-white font-weight-bold' : 'text-info'}`}>
                                                    <strong>Giriş Sonrası:</strong> {Math.round(newQuantity)} {stockItem?.unit || 'adet'}
                                                </small>
                                            )}

                                            {/* Yetersiz Stok Uyarısı */}
                                            {hasInsufficientStock && (
                                                <small className="d-block text-white font-weight-bold">
                                                    <i className="icon-exclamation"></i> Yetersiz stok! Sadece {Math.round(currentStock)} {stockItem?.unit || 'adet'} var.
                                                </small>
                                            )}

                                            {/* Max Stok Aşım Uyarısı */}
                                            {exceedsMaxStock && (
                                                <small className="d-block text-white font-weight-bold">
                                                    <i className="icon-exclamation"></i> Maksimum stok seviyesi aşılacak!
                                                </small>
                                            )}
                                        </div>
                                    )}
                                    
                                    {!formData.warehouse_id && (
                                        <small className="text-muted d-block mt-1">Birim: {stockItem?.unit || 'Adet'}</small>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Not (Opsiyonel)</label>
                                    <textarea
                                        name="notes"
                                        className="form-control"
                                        placeholder="İşlem notu ekleyebilirsiniz..."
                                        rows="3"
                                        value={formData.notes}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={toggle}
                            disabled={loading}
                        >
                            İptal
                        </button>
                        <button 
                            type="submit" 
                            className={`btn btn-${modalColor}`}
                            disabled={loading || stockLoading || Boolean(stockError) || currentStock === null || hasValidationError}
                        >
                            {loading ? (
                                <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                            ) : (
                                <><i className={iconClass}></i> {buttonLabel}</>
                            )}
                        </button>
                        {hasValidationError && (
                            <small className="text-danger d-block w-100 text-center mt-2">
                                {hasInsufficientStock && 'Yetersiz stok nedeniyle işlem yapılamaz'}
                                {exceedsMaxStock && 'Maksimum stok seviyesi aşıldığı için işlem yapılamaz'}
                            </small>
                        )}
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}

export default QuickStockModal;
